var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"receipt-view home"},[_c('Navbar'),_c('div',{attrs:{"id":"scroll-element"}},[_c('div',[_c('mini-cart')],1),_c('receipt-orders')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }